import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';

import { handleSlides } from 'utils/helpers';
// import { RenderCustomSlide } from './RenderCustomSlide';

import sampleImg from 'assets/images/noImg.png';
// import GalaxyBuds from 'assets/images/galaxy-buds.png';
// import CardMembership from 'assets/images/card-membership.png';

import 'react-image-gallery/styles/css/image-gallery.css';
import './SlideShow.scss';

const images = [
    {
        original: sampleImg,
        thumbnail: sampleImg
    }
];

SlideShowGallery.propTypes = {
    slides: PropTypes.array.isRequired,
    selectedColor: PropTypes.object,
    eligible: PropTypes.bool,
    product: PropTypes.object,
    isProductDA: PropTypes.bool
};

function SlideShowGallery({
    slides,
    selectedColor,
    product,
    isProductDA
    // eligible
}) {
    const [thumbnailPosition, setThumbnailPosition] = useState('left');
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;

    const renderCustomSlide = (item) => {
        if (item.original === handleSlides(slides, images, selectedColor)[0].original) {
            return (
                <div className='custom-slide'>
                    <img alt='' className={`first-slide-image ${isMobile && (product?.category?.name === 'Tablets' || isProductDA) ? 'w-100' : ''}`}
                        src={item.original} />
                </div>
            );
        }

        return (
            <div>
                <img className='image-gallery-image' src={item.original} alt='' />
            </div>
        );
    };

    useEffect(() => {
        function handleWindowResize() {
            const { innerWidth } = window;

            setThumbnailPosition(innerWidth < 992 ? 'bottom' : 'left');
        }

        window.addEventListener('resize', handleWindowResize);

        handleWindowResize();

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    return (
        <ImageGallery
            infinite={false}
            showIndex={false}
            additionalClass={isProductDA ? 'slideShow is-da-product' : 'slideShow'}
            items={handleSlides(slides, images, selectedColor)}
            autoPlay={false}
            disableKeyDown={true}
            lazyLoad={false}
            showNav={!isMobile}
            showBullets={true}
            showThumbnails={false}
            thumbnailPosition={thumbnailPosition}
            showPlayButton={false}
            showFullscreenButton={false}
            renderItem={!isMobile ? renderCustomSlide : null} />
    );
}

export default SlideShowGallery;
